import ModalActions from './modal-actions';

export default ModalActions;
